import { render, staticRenderFns } from "./InviteWorkspaceMembersModal.vue?vue&type=template&id=d3565936&scoped=true"
import script from "./InviteWorkspaceMembersModal.vue?vue&type=script&lang=js"
export * from "./InviteWorkspaceMembersModal.vue?vue&type=script&lang=js"
import style0 from "./InviteWorkspaceMembersModal.vue?vue&type=style&index=0&id=d3565936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3565936",
  null
  
)

export default component.exports